import * as amplitude from "@amplitude/analytics-browser"
import { plugin as engagementPlugin } from "@amplitude/engagement-browser"
export default defineNuxtPlugin(() => {
  const runtimeConfig = useRuntimeConfig()
  const { hostname } = useRequestURL()
  const subdomain = hostname.split(".")[0]
  const disableAnalytics = import.meta.dev || subdomain == "cancer"
  const { session } = useAuth()
  const workspaceId = computed(() => session.value?.user?.workspace_id)

  if (!disableAnalytics) {
    amplitude.add(engagementPlugin({ serverZone: "EU" }))

    amplitude.init(
      runtimeConfig.public.amplitudeApiKey,
      session.value?.user?.id ?? undefined,
      {
        serverZone: "EU",
        trackingOptions: {
          ipAddress: false,
          language: true,
          platform: true,
        },
        autocapture: {
          attribution: false,
          pageViews: false,
          sessions: true,
          formInteractions: false,
          fileDownloads: false,
          elementInteractions: false,
          pageUrlEnrichment: false,
          webVitals: false,
        },
      },
    )
  }

  watch(
    () => workspaceId.value,
    (workspaceId) => {
      amplitude.setOptOut(!workspaceId)

      if (workspaceId) {
        amplitude.setGroup("customer", workspaceId)
      }
    },
    { immediate: true },
  )

  // useRouter() is used here because useRoute() updates later to match the
  // rendered page content. During initial navigation, useRoute()
  // left these query params undefined for the first tracked event.
  const router = useRouter()
  const referrer = computed(() =>
    router.currentRoute.value.query.referrer?.toString(),
  )
  const placement = computed(() =>
    router.currentRoute.value.query.placement?.toString(),
  )

  return {
    provide: {
      trackEvent: (...args: Parameters<typeof amplitude.track>) => {
        if (disableAnalytics) {
          return
        }
        args[0] = `hub_${args[0]}`
        const disableRouteTracking = !!args[1]?.["disable_route_tracking"]
        if (disableRouteTracking && args[1]) {
          delete args[1]["entry_point"]
          delete args[1]["entry_placement"]
          delete args[1]["disable_route_tracking"]
        }

        if (referrer.value && !disableRouteTracking) {
          args[1] = { ...args[1], entry_point: referrer.value }
        }

        if (placement.value && !disableRouteTracking) {
          args[1] = { ...args[1], entry_placement: placement.value }
        }
        amplitude.track(...args)
      },
    },
  }
})
